module.exports = __webpack_public_path__ + "img/Ocupado.41d00cba.png";